<template>
    <div>
        <v-btn block :to="{name: 'checkout', params: {stepName: rootStep, subStepName: routes.registerPath}}" color="primary" depressed>
            {{ 'Create an account' | translation }}
        </v-btn>

        <v-btn block :to="{name: 'checkout', params: {stepName: rootStep, subStepName: routes.guestCheckout}}" color="primary" outline class="mt-2">
            {{ 'Checkout as a guest' | translation }}
        </v-btn>
    </div>
</template>

<script>
import AbstractRouteSwitcher from './AbstractRouteSwitcher';

export default {
    name: 'RegistrationLoginSwitcher',
    extends: AbstractRouteSwitcher,
    props: {
        value: Boolean,
    },
    data() {
        return {
            routes: {
                registerPath: 'registration',
                guestCheckout: 'guest-checkout',
            },
            values: {
                registerPath: false,
                guestCheckout: true,
            },
        };
    },
    created() {
        if (this.$session.get('customer-guest-switcher') !== undefined) {
            this.$emit('input', this.$session.get('customer-guest-switcher'));
        }
    },
    watch: {
        value(value) {
            if (value !== undefined && value !== null) {
                this.$session.set('customer-guest-switcher', value);
            } else {
                this.$session.remove('customer-guest-switcher');
            }
        },
        '$vuetify.breakpoint.mdAndUp'(val) {
            if (val) {
                this.$emit('input', this.defaultValue);
                this.$session.remove('customer-guest-switcher');
            }
        },
    },
};
</script>